import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import Select from 'react-select';
import Moment from 'moment';


const statusCard = [
    { count: 'totalOrder', name: 'Total Orders', subStatus: 'Order Level'},
    { count: 'completed', name: 'Completed',  subStatus: 'Order Level' },
    { count: 'inProgress', name: 'In Progress',  subStatus: 'Order Level'},
    // { count: 'pendingOrder', name: 'Pending Orders', subStatus: 'From Past 7 Days' },
]

const rawMaterialStatusCard = [
    { count: 'rawMaterialsPending', name: 'Total Approval Pending', subStatus: 'Lane Level'},
    { count: 'rawMaterialsApproved', name: 'Total Approved',  subStatus: 'Lane Level' },
    { count: 'rawMaterialsRejected', name: 'Total Rejected',  subStatus: 'Lane Level'},
]

const productionStatusCard = [
    { count: 'productionStatusPending', name: 'Total Approval Pending', subStatus: 'Lane Level'},
    { count: 'productionStatusApproved', name: 'Total Approved',  subStatus: 'Lane Level' },
    { count: 'productionStatusRejected', name: 'Total Rejected',  subStatus: 'Lane Level'},
]

class Overview extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        const { fromDate, toDate, poSearch, onSelectDateRange, onSelectPOList, poIdsList, poCountData, onSelectPONumber, poNumberList, supplierList, onSelectVendor } = this.props;
        return (
            <div className={'pr-20'}>
                <div className={'flex flex-between'}>
                    <div className={'overAllSatus'}>
                        <div className={'header'}>Over All Status</div>
                        <div className={'flex mt-15'}>
                            <div>
                                <div className="pLabel">Supplier<sup>*</sup></div>
                                <Select
                                    className={'wt-200 ht-30'}
                                    options={supplierList}
                                    onChange={onSelectVendor}
                                    isClearable
                                />
                            </div>
                            <div className={'wt-280 ml-20'}>
                                <div className="pLabel">Date Range<sup>*</sup></div>
                                <DateRangePicker 
                                    startDate={fromDate ? Moment(fromDate) : null}
                                    startDateId="startDate"
                                    endDate={toDate ? Moment(toDate) : null}
                                    endDateId="endDate"
                                    onDatesChange={({ startDate, endDate }) => {
                                        onSelectDateRange(startDate, endDate);
                                    }}
                                    focusedInput={this.state['focusedInput']}
                                    onFocusChange={focusedInput => this.setState({ ['focusedInput']: true ? focusedInput : null })}
                                    displayFormat={'DD MMM YYYY'}
                                    noBorder={true}
                                    minimumNights={0}
                                    isOutsideRange={() => false}
                                />
                            </div>
                            <div>   
                                <div className="pLabel">Project I'd<sup>*</sup></div>
                                <Select 
                                    className={'wt-200 ht-30'} 
                                    options={poIdsList}
                                    onChange={onSelectPOList}
                                    isClearable
                                />
                            </div>
                            <div className={'ml-20'}>
                                <div className="pLabel">PO Number<sup>*</sup></div>
                                <Select 
                                    className={'wt-200 ht-30'} 
                                    options={poNumberList}
                                    onChange={onSelectPONumber}
                                    isClearable
                                />
                            </div>
                        </div>
                        <div className={'flex flex-wrap flex-1 flex-between col-1'}>
                            {(statusCard || []).map((status, index) => {
                            return (
                            <div className={'status-card mt-30'}>
                                <div className={'ht-30 subLabel subHeader'}>{status.name}</div>
                                <div className="subTotal">{poCountData[status.count] || '0'}</div>
                                <div className={'ht-30 subLabel'}>{status.subStatus}</div>
                            </div>)})}
                        </div>

                        <div className={'header mt-30 mb-10 ml-20'}>Raw Materials Status</div>
                        <div className={'flex flex-wrap flex-1 flex-between col-1'}>
                            {(rawMaterialStatusCard || []).map((status, index) => {
                            return (
                            <div className={'status-card'}>
                                <div className={'ht-30 subLabel subHeader'}>{status.name}</div>
                                <div className="subTotal">{poCountData[status.count] || '0'}</div>
                                <div className={'ht-30 subLabel'}>{status.subStatus}</div>
                            </div>)})}
                        </div>

                        <div className={'header mt-30 mb-10 ml-20'}>Production Status</div>
                        <div className={'flex flex-wrap flex-1 flex-between col-1'}>
                            {(productionStatusCard || []).map((status, index) => {
                            return (
                            <div className={'status-card'}>
                                <div className={'ht-30 subLabel subHeader'}>{status.name}</div>
                                <div className="subTotal">{poCountData[status.count] || '0'}</div>
                                <div className={'ht-30 subLabel'}>{status.subStatus}</div>
                            </div>)})}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Overview;